import { CgBreakpoints } from "../../components/common/cgBreakpoints";
import { debounce } from "underscore";


export class Share {
    // staff
    window = $(window);
    metabar;
    sharetool;
    sharetoolCloned;

    constructor() {
        this.init();
    }

    init() {
        this.sharetool = $('.share-tool');
        this.metabar = $('.metabar');

        if (!this.sharetool.length || !this.metabar.length) {
            return;
        }

        this.set();
        this.bindEvents();
    }

    set() {
        this.sharetoolCloned = this.sharetool.eq(0).clone(true)
            .addClass('share-tool-opp--cloned pinned')
            .insertAfter('.metabar');
    }

    bindEvents() {
        this.window
            .on('scroll.share-tool--cloned', () => this.tick())
            .resize(debounce(() => {
                this.tick();
            }, 120));
    }

    tick() {
        if (this.isMobile() && this.isVisible()) {
            this.sharetoolCloned.addClass('share-tool--visible');
        } else {
            this.sharetoolCloned.removeClass('share-tool--visible');
        }
    }

    // auxiliary
    isMobile() {
        const cgBreakpoints = new CgBreakpoints();

        return cgBreakpoints.isMobile();
    }

    isVisible() {
        const metabarTop = this.metabar.offset().top;
        const metabarBottom = metabarTop + this.metabar.outerHeight();

        const winTop = this.window.scrollTop();
        const winBottom = winTop + this.window.outerHeight();

        return this.metabar.offset().top <= (winTop + $('#header').outerHeight()) && winBottom <= metabarBottom;
    }
}
